import { BaseModel } from '../models/BaseModel'
import 'firebase/firestore';

export class Mapper<T extends BaseModel> {
    constructor(private type: new () => T) {
    }

    public MapAny(snapshot): any {
        const data = snapshot.docs.map((doc) => doc.data()); 
        return data;
    }

    public AutoMap(snapshot): T {
        if (snapshot.empty) {
            return null;
        }
        if (snapshot.size && snapshot.size > 1) {
            throw new Error('Cannot use single automap for list of items! Use AutoMapList instead.');
        }
        let doc;
        let docId;
        
        if (snapshot.size && snapshot.size === 1) {
            // list coerced into one document
            doc = snapshot.docs[0].data();
            docId = snapshot.docs[0].id;
        } else {
            // normal single document snapshot
            doc = snapshot.data();
            docId = snapshot.id;
        }
                
        let model = new this.type();
        model = doc;
        model.id = docId;
        return model;
    }

    public AutoMapList(snapshot): T[]  {
        if (snapshot.empty) {
            return null;
        }
        let model = new Array<T>();
        snapshot.docs.map((doc) => {
            let newItem = new this.type();
            newItem = doc.data();
            newItem.id = doc.id;
            model.push(newItem);
        });
        return model;
    }

    public Map<T1>(mapAction: (from: T1, to: T) => T, source: T1): T {
        let model = new this.type();
        return mapAction(source, model);
    }

    public MapList<T1>(mapAction: (from: T1, to: T) => T, source: T1[]): T[] {
        if (source === null) {
            return null;
        }

        let model = new Array<T>();
        source.map((sourceItem) => {
            let newItem = mapAction(sourceItem, new this.type())
            model.push(newItem);    
        })
        return model;
    }
}